// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Provider_I18n = require("../../provider/Provider_I18n.bs.js");
var Organism_Header = require("../../design-system/organism/header/Organism_Header.bs.js");
var Provider_Config = require("../../provider/Provider_Config.bs.js");
var Type_Translation = require("../../generated/Type_Translation.bs.js");

var formaters_addFavorite = null;

var formaters_availabilityDate = null;

var formaters_betweenDates = null;

var formaters_date = null;

var formaters_dateWithFormat = null;

var formaters_nextBroadcastDate = null;

var formaters_nextEpisode = null;

var formaters_progress = null;

var formaters_removeFavorite = null;

var formaters_watchTrailer = null;

var formaters_weekInterval = null;

var formaters_infoSelectedDay = null;

var formaters_formValidationStringMin = null;

var formaters_formValidationStringMax = null;

var formaters = {
  addFavorite: formaters_addFavorite,
  availabilityDate: formaters_availabilityDate,
  betweenDates: formaters_betweenDates,
  date: formaters_date,
  dateWithFormat: formaters_dateWithFormat,
  nextBroadcastDate: formaters_nextBroadcastDate,
  nextEpisode: formaters_nextEpisode,
  progress: formaters_progress,
  removeFavorite: formaters_removeFavorite,
  watchTrailer: formaters_watchTrailer,
  weekInterval: formaters_weekInterval,
  infoSelectedDay: formaters_infoSelectedDay,
  formValidationStringMin: formaters_formValidationStringMin,
  formValidationStringMax: formaters_formValidationStringMax
};

function Entry_Mona_Header$Header(Props) {
  var languages = Props.languages;
  var initEvents = Props.initEvents;
  var match = React.useState(function () {
        return /* Disconnected */2;
      });
  var setUserStatus = match[1];
  var onLogin = function (param) {
    Curry._1(setUserStatus, (function (param) {
            return /* Connected */1;
          }));
  };
  var onLogout = function (param) {
    Curry._1(setUserStatus, (function (param) {
            return /* Disconnected */2;
          }));
  };
  React.useEffect((function () {
          Curry._2(initEvents, onLogin, onLogout);
        }), [initEvents]);
  return React.createElement(Organism_Header.make, {
              forcedUserStatus: match[0],
              languages: languages
            });
}

var Header = {
  make: Entry_Mona_Header$Header
};

function Entry_Mona_Header(Props) {
  var localeOpt = Props.locale;
  var myArteBaseUrl = Props.myArteBaseUrl;
  var languages = Props.languages;
  var initEvents = Props.initEvents;
  var locale = localeOpt !== undefined ? localeOpt : "fr";
  var tmp = {
    locale: locale,
    labels: Type_Translation.$$default,
    formaters: formaters,
    children: React.createElement(Entry_Mona_Header$Header, {
          languages: languages,
          initEvents: initEvents
        })
  };
  if (myArteBaseUrl !== undefined) {
    tmp.myArteBaseUrl = Caml_option.valFromOption(myArteBaseUrl);
  }
  return React.createElement(Provider_Config.make, {
              baseUrl: "https://www.arte.tv",
              children: React.createElement(Provider_I18n.make, tmp),
              trackPixel: null,
              trackPageView: null,
              trackUserAction: null,
              vodStoreHomepageUrl: null,
              playStoreUrl: null,
              appStoreUrl: null,
              appGalleryUrl: null
            });
}

var make = Entry_Mona_Header;

exports.formaters = formaters;
exports.Header = Header;
exports.make = make;
/* react Not a pure module */
